import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { notifySelectedEmployees } from '../../actions/alert_actions';
const Materialize = window.Materialize;
const $ = window.$;

class CustomModal extends React.Component {
  componentDidMount() {
    $(`#${this.props.id}`).modal();
  }
  getMobileEmployees() {
    //get list of employees with mobile phone
    let mobile = this.props.employees.filter((emp) => emp.mobilePhone);
    return mobile.map((emp, i) => <li key={i.toString()} className="collection-item">{emp.first} {emp.last}</li>)
  }

  getLandlineEmployees() {
    //get list of employees with landline phone
    let mobile = this.props.employees.filter((emp) => emp.phone);
    return mobile.map((emp, i) => <li key={i.toString()} className="collection-item">{emp.first} {emp.last}</li>)
  }

  render() {
    let d = new Date().toLocaleDateString("en-US");
    let combinedMessage = this.props.prefillMessage + " " + this.props.optionalMessage;

    return(
      <div id={this.props.id} className="modal">
        <div className="modal-content">
          <h5>Confirm Message</h5>
          <table className="modalTable">
            <tbody>
              <tr>
                <td>Date</td>
                <td>{d}</td>
              </tr>
              <tr>
                <td>Message</td>
                <td>{combinedMessage}</td>
              </tr>
            </tbody>
          </table>
          <div className="col m6 s12">
            <h6>Employees To Be Texted</h6>
            <ul className="collection modal-list">
              {this.getMobileEmployees()}
            </ul>
          </div>
          <div className="col m6 s12">
            <h6>Employees To Be Called</h6>
            <ul className="collection modal-list">
              {this.getLandlineEmployees()}
            </ul>
          </div>
          <a className="modal-close btn-flat">Cancel</a>
          <button onClick={() => {
              if (this.props.employees.length === 0) {
                Materialize.toast('No Employees Match This Criteria', 4000, 'rounded red');
              } else {
                this.props.notifySelectedEmployees(this.props.employees, combinedMessage, this.props.eid);
              }
            }} className="btn modal-close">Confirm</button>
          <br/>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    employees: state.form.chips,
    prefillMessage: state.form.prefillMessage,
    optionalMessage: state.form.optionalMessage,
    eid: state.auth.user.guid
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    notifySelectedEmployees,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);



// WEBPACK FOOTER //
// ./src/components/alert/custom-modal.js